import React from 'react';
import { RotateCcw } from 'lucide-react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, resetKey: 0 };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center bg-[#F7F8F5] px-6 pt-32 pb-16" data-testid="error-boundary-fallback">
          <div className="bg-white rounded-2xl shadow-xl p-10 text-center max-w-md">
            <h2 className="text-2xl font-bold text-[#004534] mb-3 font-['Outfit']">Oops! Kuch gadbad ho gayi</h2>
            <p className="text-gray-500 mb-6">Something went wrong on this page. Please try again.</p>
            <button
              onClick={() => this.setState(prev => ({ hasError: false, resetKey: prev.resetKey + 1 }))}
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#004534] text-white font-medium rounded-lg hover:bg-[#D4AF37] hover:text-[#004534] transition-colors"
              data-testid="error-boundary-retry-btn"
            >
              <RotateCcw className="h-4 w-4" />
              Try Again
            </button>
          </div>
        </div>
      );
    }
    return <React.Fragment key={this.state.resetKey}>{this.props.children}</React.Fragment>;
  }
}
